import { useContext } from 'react'
import { AuthContext } from '@/context/auth-context'
import type { AuthContextType } from '@/types'

/**
 * useAuth Hook
 * Provides authentication state and methods from context
 */
export const useAuth = (): AuthContextType => {
  const context = useContext<AuthContextType | undefined>(AuthContext)

  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider')
  }

  return context
}

export default useAuth
